import React from 'react';
import { lazyWithStalledPreloadRetry } from './lazy-with-stalled-preload-retry';

export const lazyRoute: typeof React.lazy = importModule => React.lazy(lazyWithStalledPreloadRetry(importModule));
